import { PartialStoreState } from '../typings'

export const selectMapMarkers = (state: PartialStoreState) =>
  state.domain.publicData.domain.mapMarkers

export const selectOrderMarkers = (state: PartialStoreState) =>
  state.domain.publicData.domain.mapMarkers.order
